import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/icomoon/icons-svg/icon-tea-cup.svg")